var _defs, _rect, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNz(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1200 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Canton"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 L 600,0 L 600,300 L 0,300 z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Diagonals"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 L 300,150 L 0,150 z M 300,0 L 600,0 L 300,150 z M 300,150 L 600,150 L 600,300 z M 300,150 L 300,300 L 0,300 z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Pentagram"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Arm",
    transform: "translate(0,-0.324925)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 L 0,0.5 L 1,0 z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 L 0,-0.5 L 1,0 z",
    transform: "rotate(-36,1,0)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Arm",
    transform: "scale(-1,1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Arm",
    transform: "rotate(72,0,0)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Arm",
    transform: "rotate(-72,0,0)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Arm",
    transform: "rotate(-72,0,0) scale(-1,1)"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#00247d",
    x: 0,
    y: 0,
    width: 1200,
    height: 600
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Flag_of_the_United_Kingdom"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Saint_Andrews_Cross",
    stroke: "#ffffff",
    d: "M 0,0 L 600,300 M 0,300 L 600,0",
    strokeWidth: 60,
    clipPath: "url(#Canton)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Saint_Patricks_Cross",
    stroke: "#cc142b",
    d: "M 0,0 L 600,300 M 0,300 L 600,0",
    strokeWidth: 40,
    clipPath: "url(#Diagonals)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Saint_Georges_Cross"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#ffffff",
    d: "M 300,0 L 300,300 M 0,150 L 600,150",
    strokeWidth: 100,
    clipPath: "url(#Canton)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#cc142b",
    d: "M 300,0 L 300,300 M 0,150 L 600,150",
    strokeWidth: 60,
    clipPath: "url(#Canton)"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Southern_Cross"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gamma_Crucis"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Pentagram",
    fill: "#ffffff",
    transform: "translate(900,120) scale(45.4)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Pentagram",
    fill: "#cc142b",
    transform: "translate(900,120) scale(30)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(82,900,240)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Delta_Crucis"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Pentagram",
    fill: "#ffffff",
    transform: "translate(900,120) rotate(-82) scale(40.4)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Pentagram",
    fill: "#cc142b",
    transform: "translate(900,120) rotate(-82) scale(25)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Beta_Crucis"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Pentagram",
    fill: "#ffffff",
    transform: "translate(900,380) rotate(-82) scale(45.4)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Pentagram",
    fill: "#cc142b",
    transform: "translate(900,380) rotate(-82) scale(30)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Alpha_Crucis"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Pentagram",
    fill: "#ffffff",
    transform: "translate(900,480) scale(50.4)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Pentagram",
    fill: "#cc142b",
    transform: "translate(900,480) scale(35)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNz);
export default __webpack_public_path__ + "static/media/nz.06845d78bff43b6440c9371aea7c0173.svg";
export { ForwardRef as ReactComponent };